import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// before App, so the first render is already in the right language
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import LocalizedThemeProvider from './i18n/LocalizedThemeProvider';
import { AuthProviderWithNavigate } from './auth/AuthProviderWithNavigate';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProviderWithNavigate>
        <LocalizedThemeProvider>
          <CssBaseline />
          <App />
        </LocalizedThemeProvider>
      </AuthProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
